import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import CustomCaption from '../../../../framework/summaryFormate/CustomCaption';
import CommodityDetailsSummary from '../../../../container/shipment/addShipment/addShipmentSummary/CommodityDetailsSummary';
import { CLERANCE_DECLARATION } from '../../../../utils/constants/constants';

const useStyles = makeStyles({
  flexContainer: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    paddingLeft: '10px',
  },
  rowDiff: {
    marginTop: '5px',
    marginBottom: '10px',
  },
});

const ClearanceDeclarationSummary = ({ shipmentData }) => {
  const {
    shipmentMovement: { name: shipmentMovement } = {},
    descriptionOfGoods,
    clearanceTotalValue,
    receipentUKIMS,
    receipentEORI,
    shipperEORI,
    shipperUKIMS,
    shippingCharges,
    reasonForExport,
    shipperDeferment,
  } = shipmentData || {};
  const classes = useStyles();
  const [commodityDetails, setCommodityDetails] = useState({});
  const CustomGridItem = ({ title, value }) => (
    <Grid item className={classes.flexContainer}>
     <CustomCaption title={title} value={value !== undefined && value !== null && value !== '' && value !== 0 ? value : (value === 0 ? '0' : '-')} />
    </Grid>
  );

  /**
   * Method to parse the commodity details
   * @returns - object
   */
  const parseCommodityDetails = () => {
    return shipmentData?.commodityDetails?.map((commodity) => {
      return {
        ...commodity,
        commodityCode: commodity?.commodityCode,
        fullDescriptionOfGoods: commodity.fullDescriptionOfGoods,
        weight: commodity?.unitWeight,
        unitValue: commodity?.unitValue,
        quantity: commodity?.quantity,
        countryOfOrigin: {
          code: commodity?.countryOfOrigin.code,
        },
      };
    });
  };

  useEffect(() => {
    const newCommodityDetails = {
      commodityDetails: parseCommodityDetails(),
    };
    setCommodityDetails(newCommodityDetails);
  }, [shipmentData]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography m={2} className={classes.rowDiff}>
          {CLERANCE_DECLARATION.SHIPMENT_MOVEMENT_TYPE} {shipmentMovement ?? '-'}
        </Typography>
      </Grid>

      {shipmentMovement === CLERANCE_DECLARATION.MOVEMENT_TYPE_C2C && (
        <>
          <CustomGridItem title={CLERANCE_DECLARATION.GOODS_DESCRIPTION} value={descriptionOfGoods} />
          <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={clearanceTotalValue} />
        </>
      )}

      {shipmentMovement === CLERANCE_DECLARATION.MOVEMENT_TYPE_C2B && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={clearanceTotalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_UKIMS_NUMBER} value={receipentUKIMS} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_EORI_NUMBER} value={receipentEORI} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovement === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={clearanceTotalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_UKIMS_NUMBER} value={shipperUKIMS} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_EORI_NUMBER} value={shipperEORI} />
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_UKIMS_NUMBER} value={receipentUKIMS} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_EORI_NUMBER} value={receipentEORI} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovement === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2C && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={clearanceTotalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_UKIMS_NUMBER} value={shipperUKIMS} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_EORI_NUMBER} value={shipperEORI} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovement !== CLERANCE_DECLARATION.MOVEMENT_TYPE_C2C && (
        <Grid item xs={12}>
          <CommodityDetailsSummary
            shipmentDetails={commodityDetails}
            isClearance={true}
            shipmentMovementType={shipmentMovement}
          />
        </Grid>
      )}

      {shipmentMovement === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B && !shipperUKIMS && (
        <>
          <CustomGridItem title={CLERANCE_DECLARATION.SHIPPING_CHARGES} value={shippingCharges} />
          <CustomGridItem title={CLERANCE_DECLARATION.REASON_FOR_EXPORT} value={reasonForExport} />
          <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_DEFERMENT_NUMBER} value={shipperDeferment} />
        </>
      )}
    </Grid>
  );
};

ClearanceDeclarationSummary.propTypes = {
  shipmentData: PropTypes.object.isRequired,
};

export default ClearanceDeclarationSummary;
